<template>
  <ui-banner v-if="visible" tone="info" icon="mdi-clock-outline" class="fin-pending">
    <b>{{ $t("finance_shell.pending.title", { count: result.count, sum: money(result.valueSum) }) }}</b>
    <span v-if="oldest" class="fin-pending__old">{{ $t("finance_shell.pending.oldest", { date: localeDate(oldest) }) }}</span>
    <button type="button" class="ui-text-btn" @click="openList">{{ $t("finance_shell.pending.show") }}</button>
  </ui-banner>
</template>

<script>
import restaurantFinanceService from "@/services/restaurantFinance";
import { formatMoney } from "@/components/restaurant/finance/constants";
import PendingPanel from "../panels/PendingPanel.vue";
import { mapPendingList, oldestFinalAt } from "../financeLogic";

/**
 * Traka "Narudžbe koje čekaju knjiženje" (GET restaurants/{id}/ledger/pending za izabrani period): završene narudžbe kojima još
 * nema knjiženja, pa nisu u zaradi ni u transakcijama. Samo pregled: restoran ne može sam knjižiti (noćna provjera ili admin).
 * Traka se ne prikazuje kad nema takvih narudžbi i kad poziv ne uspije (ne smije rušiti ekran).
 */
export default {
  name: "FinancePendingBar",
  inject: { shell: "reportShell" },
  props: { period: { type: Object, required: true } },
  data: () => ({ result: { rows: [], count: 0, valueSum: 0, note: "" } }),
  computed: {
    visible() {
      return this.result.count > 0;
    },
    oldest() {
      return oldestFinalAt(this.result.rows);
    },
    periodKey() {
      return `${this.period.from}|${this.period.to}`;
    },
  },
  watch: {
    periodKey: "load",
  },
  created() {
    this.seq = 0;
    this.load();
  },
  methods: {
    money(value) {
      return formatMoney(value, this.shell.currency);
    },
    async load() {
      const id = this.shell.restaurantId;
      if (!id) return;
      const seq = ++this.seq;
      try {
        const { data } = await restaurantFinanceService.getPendingLedger(id, { from: this.period.from, to: this.period.to });
        if (seq === this.seq) this.result = mapPendingList(data);
      } catch (error) {
        if (seq === this.seq) this.result = { rows: [], count: 0, valueSum: 0, note: "" };
      }
    },
    openList() {
      this.shell.openPanel({
        key: "pending-ledger",
        title: this.$t("finance_shell.pending.panel_title"),
        subtitle: `${this.localeDate(this.period.from)} – ${this.localeDate(this.period.to)}`,
        component: PendingPanel,
        props: { rows: this.result.rows, count: this.result.count, valueSum: this.result.valueSum, note: this.result.note, currency: this.shell.currency },
        root: true,
      });
    },
  },
};
</script>
